import { Box, Typography } from "@mui/material";
import React from "react";
import Orangelogo from "../../assets/images/Orangelogo.png";
import Email from "../../assets/icons/Frame 132.png";
import Contact from "../../assets/icons/Frame 142.png";
import LinkedIn from "../../assets/icons/Frame 143.png";
import { Link } from "react-router-dom";

const ContactusMap = () => {
  return (
    <Box
      sx={{
        width: "100%",
        marginTop: "2rem",
        display: "flex",
        flexDirection: { xs: "column", sm: "row" },
        padding: { xs: "0rem 1.8rem", sm: "0rem 4rem" },
        backgroundColor: "#ecebeb",
      }}
    >
      <Box
        sx={{
          width: { xs: "100%", sm: "100%" },
        }}
      >
        <Box
          sx={{
            width: "4rem",
            marginTop: { xs: "1rem", sm: "2rem" },
          }}
        >
          <img src={Orangelogo} alt="Orange Logo" width="100%" />
        </Box>
        <Typography
          sx={{
            color: "rgba(35, 35, 37, 1)",
            fontFamily: "Montserrat",
            fontSize: { xs: "0.8rem", sm: "1rem" },
            marginTop: "0.4rem",
            fontWeight: "400",
          }}
        >
          CONTACT US
        </Typography>
        <Typography
          sx={{
            fontFamily: "Montserrat",
            fontSize: { xs: "1.4rem", sm: "1.6rem" },
            fontWeight: "500",
            marginTop: "0.8rem",
          }}
        >
          Let's
          <span style={{ color: "rgba(255, 102, 0, 1)" }}> get in touch!</span>
        </Typography>

        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            flexWrap: "wrap",
            gap: { xs: "1rem", md: "4.5rem" },
            marginTop: "2rem",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: "1rem",
              flex: "1 1 auto",
              backgroundColor: "rgba(241, 241, 241, 1)",
              borderRadius: "1rem",
              padding: "1rem",
            }}
          >
            <Box sx={{ width: "2.5rem", aspectRatio: "1 / 1" }}>
              <img src={Email} alt="Email" width="100%" />
            </Box>
            <Box>
              <Typography
                sx={{ fontFamily: "Plus Jakarta Sans", fontWeight: "500", color: "#333333" }}
              >
                Email
              </Typography>
              <Typography sx={{ fontFamily: "Plus Jakarta Sans", fontWeight: "500", color: "rgba(51, 51, 51, 1)" }}>
                info@inteliphyle.com
              </Typography>
            </Box>
          </Box>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: "1rem",
              flex: "1 1 auto",
              backgroundColor: "rgba(241, 241, 241, 1)",
              borderRadius: "1rem",
              padding: "1rem",
            }}
          >
            <Box sx={{ width: "2.5rem", aspectRatio: "1 / 1" }}>
              <img src={Contact} alt="Contact" width="100%" />
            </Box>
            <Box>
              <Typography
                sx={{ fontFamily: "Plus Jakarta Sans", fontWeight: "500", color: "#333333" }}
              >
                Contact
              </Typography>
              <Typography sx={{ fontFamily: "Plus Jakarta Sans", fontWeight: "500", color: "rgba(51, 51, 51, 1)" }}>
                +91 9876543210
              </Typography>
            </Box>
          </Box>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: "1rem",
              flex: "1 1 auto",
              backgroundColor: "rgba(241, 241, 241, 1)",
              borderRadius: "1rem",
              padding: "1rem",
            }}
          >
            <Link to="https://www.linkedin.com/company/inteliphyle/" target="_blank" rel="noopener noreferrer">
              <Box sx={{ width: "2.5rem", aspectRatio: "1 / 1" }}>
                <img src={LinkedIn} alt="LinkedIn" width="100%" />
              </Box>
            </Link>
            <Link to="https://www.linkedin.com/company/inteliphyle/" target="_blank" rel="noopener noreferrer" style={{ textDecoration: "none", color: "#333333" }}>
              <Box>
                <Typography
                  sx={{ fontFamily: "Plus Jakarta Sans", fontWeight: "500", color: "#333333" }}
              >
                LinkedIn
              </Typography>
              <Typography sx={{ fontFamily: "Plus Jakarta Sans", fontWeight: "500", color: "rgba(51, 51, 51, 1)" }}>
                Inteliphyle
                </Typography>
              </Box>
            </Link>
          </Box>
        </Box>
      </Box>

      {/* <Box sx={{ width: { xs: '100%', sm: '50%' }, marginTop: { xs: '2rem', sm: '8rem' } }}>
        <iframe
          title="Google Map"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3151.835434509771!2d144.95565131531664!3d-37.817327979751524!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6ad642af0f11fd81%3A0x5045675218ce6e0!2sVictoria%20Harbour%2C%20Docklands%20VIC%203008%2C%20Australia!5e0!3m2!1sen!2sus!4v1609739514510!5m2!1sen!2sus"
          width="90%"
          height="360"
          style={{ border: 0 }}
          allowFullScreen=""
          loading="lazy"
        ></iframe>
      </Box> */}
    </Box>
  );
};

export default ContactusMap;
